<template>
  <div class="cases-area">
    <Banner :imageSlides="imageSlides" v-if="this.isMajorDonor" :showButtons="false" />
    <div class="text-center fw-bold fs-2 py-4" data-cy="cases-list-header">الحالات</div>
    <div v-if="this.isMajorDonor" class="filters-form p-4 mb-4 d-flex align-items-center justify-content-center"
      data-cy="filters-form">
      <div class="filters-form__inputs">
        <div class="filters-form__region">
          <label class="filters-form__top-label">المنطقة</label>
          <Dropdown class="w-100" data-cy="region-dropdown" optionValue="id" v-model="this.queryParams.region"
            :options="this.regionOptions" optionLabel="name" :filter="true" placeholder="اختر المنطقة" />
        </div>
        <div class="filters-form__specialization">
          <label class="filters-form__top-label">التخصص</label>
          <Dropdown class="w-100" data-cy="specialization-dropdown" optionValue="id"
            v-model="this.queryParams.specialty" :options="this.specializationOptions" optionLabel="name" :filter="true"
            placeholder="اختر التخصص" />
        </div>
        <div class="filters-form__type h-100 d-flex flex-column justify-content-between">
          <label class="filters-form__top-label">الفئة</label>
          <div class="filter-form__radio-group">
            <RadioButton class="position-relative" input-id="man" name="patient_testing" value="1"
              v-model="this.queryParams.patient_type" data-cy="filter-radio-man" />
            <label for="man" class="filters-form__label">رجال</label>
            <RadioButton class="position-relative" input-id="woman" name="patient_testing" value="2"
              v-model="this.queryParams.patient_type" data-cy="filter-radio-woman" />
            <label for="woman" class="filters-form__label">نساء</label>
            <RadioButton class="position-relative" input-id="child" name="patient_testing" value="3"
              v-model="this.queryParams.patient_type" data-cy="filter-radio-child" />
            <label for="child" class="filters-form__label">أطفال</label>
          </div>
        </div>
        <div class="filters-form__search">
          <span class="p-input-icon-right w-100">
            <i class="pi pi-search" />
            <input type="number" class="w-100 p-inputtext p-component p-inputnumber-input" :useGrouping="false"
              v-model="this.queryParams.case_id" placeholder="ابحث حسب رقم الحالة" @keydown.enter="submit"
              data-cy="filters-form-search-input" />
          </span>
        </div>
        <Button class="p-button-primary filters-form__button" label="بحث" data-cy="submit-btn" @click="submit" />
        <Button class="p-button-outlined filters-form__reset" label="مسح الفلاتر" @click="clearFilters" />
      </div>
    </div>
    <BaseSpinner :size="4" class="py-5" v-if="loading" />
    <div v-else-if="!loading && cases?.length">
      <div class="row mx-2 mx-md-4">
        <CardBoard type="cases" :items="cases" />
      </div>
    </div>
    <div v-else>
      <div class="text-center fw-bold fs-2 py-5">لا يوجد حالات</div>
    </div>
    <div class="row mt-5" v-if="cases?.length">
      <Paginator :rows="9" :totalRecords="totalItemsCount" :first="firstItemIndex" @page="onPageChange($event)">
      </Paginator>
    </div>
  </div>
</template>

<script>
import CardBoard from "@/components/home/CardBoard";
import CaseService from "@/services/case-service";
import { useHead } from '@vueuse/head'
import BaseSpinner from "@/components/layout/BaseSpinner";
import { setLocalValue, getLocalValue, removeLocalValue } from "@/hooks/useLocalStorage";
import { REGIONS, SPECIALTIES } from '@/services/enum.service';
import Banner from '@/components/home/Banner.vue';
import HomePageService from "@/services/home-page.service";

export default {
  name: "cases-list",
  components: { CardBoard, BaseSpinner, Banner },
  setup() {
    useHead({
      title: 'الحالات',
      meta: [
        {
          name: `description`,
          content: 'كن عونًا لهم بعطائك',
        },
      ],
    })
  },
  data() {
    return {
      cases: [],
      queryParams: {
        page: 1,
        page_size: 9,
        group: null,
        specialty: null,
        region: null,
        case_id: null,
        patient_type: null
      },
      totalItemsCount: 9,
      loading: false,
      regionOptions: REGIONS,
      specializationOptions: SPECIALTIES,
      imageSlides: null,
      isMajorDonor: getLocalValue('client-id')?.includes('major-donor') || false,
    };
  },
  computed: {
    firstItemIndex() {
      return (this.queryParams.page - 1) * this.queryParams.page_size;
    }
  },
  mounted() {
    if (this.isMajorDonor) { this.getBannerData(); }
    if (getLocalValue('selectedPage') && getLocalValue('selected_case_id')) {
      this.queryParams.page = getLocalValue('selectedPage');
    } else {
      removeLocalValue('selectedPage')
    }
    if (this.$route.query.group) {
      this.queryParams.group = this.$route.query.group;
    }
    if (this.$route.query.specialty) {
      this.queryParams.specialty = this.$route.query.specialty;
    }
    this.getCards(this.queryParams);
  },
  methods: {
    getCards(queryParams) {
      this.loading = true
      CaseService.getCaseCardList(queryParams)
        .then(({ data: { result } }) => {
          this.cases = result?.results;
          this.totalItemsCount = result?.total_objects;
        }).finally(() => {
          this.loading = false
        });
    },
    onPageChange(event) {
      this.queryParams.page = event.page + 1;
      setLocalValue('selectedPage', this.queryParams.page);
      this.getCards(this.queryParams);
    },
    submit() {
      this.queryParams.page = 1;
      this.getCards(this.queryParams);
      setLocalValue('selectedPage', this.queryParams.page);
    },
    clearFilters() {
      this.queryParams.region = null;
      this.queryParams.specialty = null;
      this.queryParams.patient_type = null;
      this.queryParams.case_id = null;
      this.queryParams.page = 1;
    },
    getBannerData() {
      HomePageService.getHomePageDetails().then(({ data: { result } }) => {
        this.imageSlides = result.banner;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/abstracts/mixins";
@import "@/styles/variables";

.cases-area {
 background: $color-primary-background url(#{$static-url}/static/images/polygon.png) no-repeat right;
}
::v-deep(.p-paginator) {

  .p-paginator-first,
  .p-paginator-prev,
  .p-paginator-next,
  .p-paginator-last {
    transform: rotate(180deg);
  }
}

.filters-form {

  &__inputs {
    display: grid;
    grid-template-areas: 'region specialization type search button reset';
    grid-template-columns:
      minmax(100px, 190px) minmax(100px, 200px) minmax(100px, 222px) minmax(100px, 200px) minmax(70px, 130px) minmax(40px, 130px);
    align-items: end;
    grid-gap: 15px;
  }

  &__search {
    grid-area: search;
  }

  &__type {
    grid-area: type;
  }

  &__specialization {
    grid-area: specialization;
  }

  &__region {
    grid-area: region;
  }

  &__reset {
    grid-area: reset;
  }

  &__button {
    grid-area: button;
  }

  &__top-label,
  &__label {
    color: $color-font-lighter;
    margin-right: 13px;
  }

  &__label {
    margin-right: 4px;
    margin-left: 10px;
  }

  ::v-deep(.p-dropdown .p-dropdown-label.p-placeholder) {
    color: $color-font-lighter;
  }

  ::v-deep(.p-inputtext::placeholder) {
    color: $color-font-lighter;
  }

  ::v-deep(.p-inputnumber-input) {
    padding-right: 2.2rem;
  }

  @include respond('xl') {
    min-width: 80%;
    padding: 10px 20px;

    &__inputs {
      grid-template-areas: 'region specialization'
        'type search'
        'button reset';
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @include respond('md') {
    width: 98%;
    font-size: 14px;

    ::v-deep(.p-dropdown .p-dropdown-label) {
      font-size: 14px;
    }

    ::v-deep(.p-inputtext) {
      font-size: 14px;
    }
  }

  @include respond('sm') {

    &__inputs {
      grid-template-areas: 'region'
        'specialization'
        'type'
        'search'
        'button'
        'reset';
      grid-template-columns: 1fr;
    }
  }
}
:deep(.p-paginator){
  background: none;
}
</style>
